import { useState, useEffect } from 'react';
import api from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Heart, CheckCircle, XCircle, Clock } from 'lucide-react';

const statusColor = (s) => {
  if (s === 'success' || s === 'completed') return 'bg-emerald-100 text-emerald-700';
  if (s === 'failed') return 'bg-red-100 text-red-700';
  return 'bg-amber-100 text-amber-700';
};

export default function CustomerDonations() {
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/customer/donations')
      .then(r => setDonations(r.data.donations || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const fmt = (v) => new Intl.NumberFormat('id-ID').format(v || 0);

  if (loading) return (
    <div className="flex items-center justify-center h-64">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[var(--store-primary, #2D6CDF)]" />
    </div>
  );

  return (
    <div data-testid="customer-donations-page">
      <div className="mb-6">
        <h1 className="text-2xl font-bold tracking-tight text-slate-900" style={{ fontFamily: 'Plus Jakarta Sans' }}>Riwayat Donasi</h1>
        <p className="text-sm text-slate-500 mt-1">Histori donasi dan kampanye yang Anda dukung</p>
      </div>

      {donations.length === 0 ? (
        <Card className="border-slate-200 shadow-sm">
          <CardContent className="py-16 text-center">
            <Heart size={48} className="mx-auto text-slate-300 mb-4" />
            <h3 className="font-medium text-slate-900 mb-1">Belum ada riwayat donasi</h3>
            <p className="text-sm text-slate-500">Donasi yang Anda buat akan muncul di sini</p>
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-3">
          {donations.map(don => (
            <Card key={don.id} className="border-slate-200 shadow-sm">
              <CardContent className="p-5">
                <div className="flex items-start justify-between gap-4">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-rose-50 flex items-center justify-center shrink-0">
                      <Heart size={20} className="text-rose-500" />
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">{don.campaign_title || don.campaign_name || 'Donasi'}</p>
                      {don.message && <p className="text-sm text-slate-500 italic mt-0.5">"{don.message}"</p>}
                      <p className="text-xs text-slate-400 mt-1">
                        {new Date(don.created_at).toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' })}
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-col items-end gap-2">
                    <p className="font-bold text-rose-600 text-lg">Rp {fmt(don.amount)}</p>
                    <Badge className={statusColor(don.status)}>{don.status}</Badge>
                    {don.is_anonymous && <span className="text-xs text-slate-400">Anonim</span>}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
